import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { works } from "@/mocks/works";

export default function CategorySection() {
  return (
    <section className="container-x py-14 md:py-20" aria-labelledby="cat-heading">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            剧情分类
          </span>
          <h2 id="cat-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            想看哪类，直接点
          </h2>
        </div>
        <Link
          to="/faq"
          className="hidden items-center gap-1 text-sm font-medium whitespace-nowrap text-foreground-600 hover:text-primary-700 md:inline-flex"
        >
          浏览说明 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => {
          const count = works.filter((w) => w.categorySlug === c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-2xl`} />
                </span>
                <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-500">
                  {count} 部作品
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {c.name}
                <span className="ml-2 text-xs font-normal text-foreground-400">{c.en}</span>
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {c.tagline}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                查看作品
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}